module.exports = __webpack_public_path__ + "img/text-1.436e05d.jpg";